import {ReactNode} from "react";
import {Button, DialogActions, DialogContent, DialogTitle, Divider, Modal, ModalDialog, Stack} from "@mui/joy";
import {ColorPaletteProp} from "@mui/joy/styles";

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    description: ReactNode;
    confirmLabel: string;
    cancelLabel: string;
    confirmColor?: ColorPaletteProp;
    loading?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

// Sostituisce window.confirm/alert nativi (bruttini, fuori dal tema
// dell'app) con un dialog Joy vero, riusabile ovunque serva chiedere
// conferma prima di un'azione (es. disdetta/riattivazione abbonamento).
export function ConfirmDialog(props: ConfirmDialogProps) {
    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog variant="outlined" role="alertdialog">
                <DialogTitle>{props.title}</DialogTitle>
                <Divider />
                <DialogContent>{props.description}</DialogContent>
                <DialogActions>
                    <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{width: "100%"}}>
                        <Button
                            variant="plain"
                            color="neutral"
                            onClick={props.onClose}
                            disabled={props.loading}
                        >
                            {props.cancelLabel}
                        </Button>
                        <Button
                            variant="solid"
                            color={props.confirmColor ?? "primary"}
                            onClick={props.onConfirm}
                            loading={props.loading}
                        >
                            {props.confirmLabel}
                        </Button>
                    </Stack>
                </DialogActions>
            </ModalDialog>
        </Modal>
    );
}
